@if(readonly) {
  <span>{{ internalValue }}</span>
} @else {
  <input
    pInputText
    type="text"  
    styleClass="w-100"
    [ngModel]="internalValue"
    (ngModelChange)="updateChanges($event)" /> 
}